import { Link } from "react-router-dom";
import Logo from "../../../assets/icons/JKHInfoLogo.png";

export const JKHInfoLogo = () => {
  return (
    <Link to="/" className="header__krk">
      <img src={Logo} alt="Логотип" style={{maxWidth: "45px"}}></img>
    </Link>
  );
};
